import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'components/base/base.component';
import { lastValueFrom, Subscription } from 'rxjs';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { JornadaPsicologo, JornadaPsicologoAtividade, JornadaPsicologosInserir } from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { FiltroTabulator } from 'src/app/shared/models/tabulator/FiltroTabulator';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { FiltroService } from 'src/app/shared/services/filtro.service';
import { RelogioPontoService } from 'src/app/shared/services/modal-relogioPonto.service';
import { PsicologoUtilsService } from 'src/app/shared/services/psicologo-utils.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import {
  jornadaEstaAprovada,
  possuiCheckoutEfetivo,
} from 'src/app/shared/utils/jornada-em-aberto-modal';

@Component({
    templateUrl: './registro-saida.component.html',
    styleUrls: ['./registro-saida.component.scss'],
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports],
    standalone: true
})

export class PageRegistroSaidaComponent extends BaseComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  get getAtividadeParaAprovar(): boolean{
    return this.lstAtividades.some(x=>x.statusAprovacao == 0)
  }

  subs: Subscription[] = [];
  formInserir!: FormGroup;
  get form() {
    return this.formInserir.controls;
  }
  totalHorasTrabalhadas?: Date;
  totalHorasAtividades?: Date;
  totalHorasTempoRegistro?: Date;
  HorariocheckOut?:Date;
  jornadaId?: number;
  isCheckoutFlow: boolean = false;
  atividadeIdSelecionada?: number;
  showModal: boolean = false;
  showModalAprovacao: boolean = false;
  //Range minimo e maximo das datas
  get minDate(): Date {
    return this.jornadaNaoFinalizada ? new Date(this.jornadaNaoFinalizada?.dataInicio) :
      new Date();
  }

  get maxDate(): Date {
    return new Date();
  }
  get dataInicio(): Date {
    return this.jornadaNaoFinalizada?.stAjusteAprovacaoEntrada == 1 ? new Date(this.jornadaNaoFinalizada?.hrAjusteEntrada!) : this.jornadaNaoFinalizada?.dataInicio ?? new Date(0, 0, 0, 0, 0)
  }

  get dataFim(): Date {
    return this.HorariocheckOut ?? new Date(0, 0, 0, 0, 0)
  }
  //Grid Variables
  lstAtividades: JornadaPsicologoAtividade[] = [];

  public colunasGrid = [
    { title: 'Data da visita à URE/Escola', field: 'dataAtividade', width: 220, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Data Registro', field: 'dataOperacao', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: (cell: any) => {
      const value = cell.getValue();
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }},
    { title: 'Título da Atividade', field: 'titulo', width: 300, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Tipo de Atividade', field: 'tipoAtividadeStr', width: 175, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Polo/Diretoria', field: 'poloDiretoria', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: this.observacaoFormatter },
    { title: 'Escola', field: 'escola', width: 300, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Qtde Horas', field: 'tempoAtividade', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    {
      title: 'Ações', field: 'acoes', hozAlign: "center", width: 100, formatter: function (cell: any, formatterParams: any, onRendered: any) {
        const atividade = cell.getRow().getData() as JornadaPsicologoAtividade;
        return `<div style='display:inline-flex;gap:0.4em;'>
        <i class='fa fa-eye' aria-hidden='true' title='Visualizar Atividade'></i>

         ${ atividade.statusAprovacao == 0 || atividade.statusAprovacao == 1 ? "<i class='fa fa-trash' aria-hidden='true' title='Remover Atividade'></i>" : ""}
        ${ atividade.statusAprovacao == 0 || atividade.statusAprovacao == 1 ? "<i class='fa fa-edit'  aria-hidden='true' title='Editar Atividade'></i>" : ""}
        </div>`;
      }, headerHozAlign: "center",
      cellClick: (e: any, cell: any) => this.OnClickAcao(e, cell)
      // ,visible:this.podeVerColuna
    },

  ];

  async ngOnInit() {
    this.formInserir = new FormGroup({
      justificativa: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      tipoRegistro: new FormControl(),
      horaEntrada: new FormControl(null, [Validators.required]),
      horaSaida: new FormControl(null, [Validators.required]),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null, [Validators.required]),
      dataSaida: new FormControl(null, [Validators.required]),
    });
    this.setJornadaId();
    this.setSubscriptions();
    await this.getJornada();
    await this.carregarJornadaAtivaUsuario();
    this.setJustificativaTempoRegistro();



  }
  setJustificativaTempoRegistro() {
    this.formJustificarTempoRegistro.get('justificativa')?.setValue(this.jornadaNaoFinalizada?.descricaoJustificativaTempoRegistro);
  }


  setJornadaId() {
    this.isCheckoutFlow = this.activatedRoute.snapshot.queryParamMap.get('flow') === 'checkout';
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.jornadaId = params.jornada;
        this.isCheckoutFlow = params.flow === 'checkout';
      });

  }

  async getJornada(){
    if(this.jornadaId)
      await this.getJornadaPorId(this.jornadaId);
    else
      await this.getJornadaEmAberto();

  }

  setSubscriptions() {
    this.subs.push(
      this.relogioPontoService.modalFinalizarJornada$.subscribe(async (eventCloseModal: boolean) => {
        if (!eventCloseModal && this.jornadaNaoFinalizada)
          await this.getJornadaPorId(this.jornadaNaoFinalizada!.codigoJornada)
      }
      ),
      this.relogioPontoService.modalIniciarJornada$.subscribe(async (eventCloseModal: boolean) => {
        if (!eventCloseModal) {
          await this.carregarJornadaAtivaUsuario();
          if (this.jornadaAtivaUsuario && !this.jornadaId) {
            await this.getJornadaEmAberto();
          }
        }
      })
    );
  }

  //Injections
  // spinner = inject(NgxSpinnerService);
  errorHandler = inject(ConvivaErrorHandlingService);
  fb = inject(FormBuilder);
  filtroService = inject(FiltroService);
  relogioPontoService = inject(RelogioPontoService);
  activatedRoute = inject(ActivatedRoute);
  psicologoUtilsService = inject(PsicologoUtilsService);

  filtrosTabela: FiltroTabulator[] = [
    {
      value: 'nomePsicologo',
      label: 'Psicólogo'
    },
    {
      value: 'dataEntrada',
      label: 'Data Entrada'
    },
    {
      value: 'poloDiretoria',
      label: 'Polo/Diretoria'
    }
  ];
  jornadas: JornadaPsicologo[] = [];
  jornadaNaoFinalizada?: JornadaPsicologo;
  private jornadaAtivaUsuario?: JornadaPsicologo;
  private codigoJornadaEmAberto: number | null = null;
  private readonly perfisInserirAtividade: Perfil[] = [
    Perfil.GestorConviva,
    Perfil.Psicólogo,
    Perfil.CoordenadorPsicologo,
  ];
  escolasDiretor: Escola[] = this.escolas;
  formJustificarTempoRegistro: FormGroup = this.fb.group({
    justificativa: this.fb.control(''),
  });



  get podeVerColuna() {
    return [
      Perfil.GestorConviva,
      Perfil.GestorCGRH,
      Perfil.PEC,
      Perfil.CoordenadorPsicologo,
      Perfil.FiscalPsicologo
    ].includes(this.userLogado?.codigoPerfil!);
  }






  async getJornadas(filtros: FiltroPadrao) {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getJornadas(
      filtros.codigoPolo!,
      filtros.codigoDiretoria,
      filtros.codigoEscola,
      this.userLogado?.codigoPerfil == Perfil.Psicólogo ? this.userLogado?.cpf : null))
      .catch(err => this.errorHandler.handleResultError(err));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }
    this.jornadas = response.data;
    this.toastr.success("Jornadas encontradas com sucesso!");
    this.spinnerService.hide();
  }

  public async UserBehavior() {

    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo) {
      this.carregarDiretoriasVinculadasCoordenador();
    }
    else if (this.userLogado?.flPsicologo) {
      await this.getDiretoriasPerfilPsicologo();
    }
    else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getDiretoriasAdmin();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getDiretoriasPerfilDiretoria();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 3 ||
        this.atribuicoesLogin.NumeroComportamento == 4) {
        await this.getDiretoriasPerfilEscola();
      }
    }


    this.disableVoidInputs();
    await this.activeDiretoria();

    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo && this.diretorias.length === 1) {
      const codigo = this.diretorias[0].codigoDiretoria;
      if (this.formInserir.get('codigoDiretoria')?.value !== codigo) {
        this.formInserir.get('codigoDiretoria')?.enable();
        this.formInserir.get('codigoDiretoria')?.setValue(codigo);
        await this.getEscolas();
      }
      this.formInserir.get('codigoDiretoria')?.disable();
    }
  }

  private carregarDiretoriasVinculadasCoordenador(): void {
    const atual = Number(this.userLogado?.codigoDiretoria ?? 0);
    const vistos = new Set<number>();
    this.diretorias = [];

    const atribuicoes = (this.userLogado?.DadosUsuario ?? []).filter((item) => {
      const codigo = Number(item.CodigoDiretoria);
      if (atual > 0) {
        return codigo === atual;
      }
      return codigo > 0;
    });

    for (const item of atribuicoes) {
      const codigo = Number(item.CodigoDiretoria);
      if (codigo > 0 && !vistos.has(codigo)) {
        vistos.add(codigo);
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = codigo;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        this.diretorias.push(diretoria);
      }
    }

    if (this.diretorias.length === 0 && atual > 0) {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = atual;
      diretoria.nomeDiretoria = this.userLogado?.DadosUsuario?.find((item) => Number(item.CodigoDiretoria) === atual)?.NomeDiretoria
        ?? this.userLogado?.DadosUsuario?.[0]?.NomeDiretoria
        ?? '';
      this.diretorias.push(diretoria);
    }
  }

  setUserLogado() {
    const user = this.authService.getUser();
    if (!user)
      this.router.navigate(['/logout']);

    return user;
  }

  observacaoFormatter(cell: any) {
    const value = cell.getValue();
    return value ? value : 'sem observação'; // Retorna "sem observação" se o valor for null ou vazio
  }

  private async getDiretoriasPerfilPsicologo() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public async getDiretoriasAdmin() {
    this.spinnerService.show();


    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

    });

    if (this.diretorias.length === 1) {
      this.formInserir.get('codigoDiretoria')!.disable();
    }

    this.spinnerService.hide();

  }

  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.spinnerService.show();
    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
      this.escolasDiretor.push(escola);

    });
    this.spinnerService.hide();



  }

  async activeDiretoria() {

    if (this.diretorias != undefined && this.userLogado?.codigoDiretoria != 0) {
      const diretoria = this.diretorias.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria)
      if (diretoria) {
        this.formInserir.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
        this.formInserir.get('codigoDiretoria')?.enable();
        await this.getEscolas();
      }
    }
  }

  async activeEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola) {
        this.formInserir.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
      }
    }
  }

  disableVoidInputs() {

    // if(this.template == TemplateFiltroPadrao.Polo){
    //   this.form.codigoDiretoria.setValue(null);
    //   this.form.codigoDiretoria.disable();
    // }
    this.formInserir.get('codigoDiretoria')!.setValue(null);
    this.formInserir.get('codigoDiretoria')!.disable();
    this.formInserir.get('codigoEscola')!.setValue(null);
    this.formInserir.get('codigoEscola')!.disable();
  }


  SetBodyParametersInserir(): JornadaPsicologosInserir {
    const { horaEntrada, horaSaida } = this.formInserir.value;

    const [dataParte] = horaEntrada.split('T');

    const [horas, minutos] = horaSaida.split(':');

    const dataFimIso = `${dataParte}T${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
    const dataFimDate = new Date(dataFimIso);
    const DataFimLocal = this.formatLocalISO(dataFimDate);

    const escolaSem = this.escolas.find(x =>
      x.codigoEscola == this.formInserir.get('codigoEscola')?.value);

    const nomeEscolaSemCodigo = escolaSem?.nomeEscola.replace(/^[0-9]+\s*-\s*/, '') ?? '';

    return {
      codigoDiretoria: this.formInserir.get('codigoDiretoria')?.value,
      codigoEscola: this.formInserir.get('codigoEscola')?.value,
      nomeDiretoria: this.diretorias.find(x => x.codigoDiretoria == this.formInserir.get('codigoDiretoria')?.value)?.nomeDiretoria,
      nomeEscola: nomeEscolaSemCodigo,
      justificativa: this.formInserir.get('justificativa')?.value,
      codigoPsicologo: Number(this.userLogado?.cpf),
      dataInicio: horaEntrada,
      dataFim: DataFimLocal,
    };
  }

  public formatLocalISO(dt: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    const Y = dt.getFullYear();
    const M = pad(dt.getMonth() + 1);
    const D = pad(dt.getDate());
    const h = pad(dt.getHours());
    const m = pad(dt.getMinutes());
    return `${Y}-${M}-${D}T${h}:${m}`;
  }



  async searchHandler(event: FiltroPadrao) {
    this.filtros = event;
    // await this.getJornadas(this.filtros);
  }


  setFilters(event: FiltroPadrao) {
    this.filtros = event;

  }

  public async getEscolas() {
    this.spinnerService.show();

    const codigoDE = this.formInserir.get('codigoDiretoria');
    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo ||
      this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 1 ||
      this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 2 ||
      this.userLogado?.DadosUsuario[0].CodigoPerfil == Perfil.Psicólogo) {
      //this.zerarEscola();
      if (codigoDE?.value != null) {
        this.spinnerService.show();
        const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE?.value));
        if (!response.isSucess) {
          this.toastr.error(response.message);
        }
        this.escolas = response.data;
        this.formInserir.get('codigoEscola')!.enable();
        this.spinnerService.hide();
      }
    }
    this.spinnerService.hide();
  }

  public zerarEscola() {
    this.escolas = [];
    this.formInserir.get('codigoEscola')!.patchValue(null);
    this.formInserir.get('codigoEscola')!.disable();
  }

  /** Visibilidade do "+"; regra de negócio validada em redirectToAddAtividade (toast). */
  exibirBotaoAdicionarAtividade(): boolean {
    const temPerfil = this.perfisInserirAtividade.includes(this.userLogado?.codigoPerfil as Perfil);
    if (!temPerfil) {
      return false;
    }

    return !jornadaEstaAprovada(this.jornadaNaoFinalizada);
  }

  async redirectToAddAtividade() {
    await this.carregarJornadaAtivaUsuario();

    const jornadaAlvo = this.jornadaId
      ? this.jornadaNaoFinalizada
      : (this.jornadaAtivaUsuario ?? this.jornadaNaoFinalizada);
    const codigoJornada = jornadaAlvo?.codigoJornada;

    if (!codigoJornada) {
      this.toastr.error('Código da jornada não encontrado.');
      return;
    }

    if (!this.podeInserirAtividadeNaJornada(jornadaAlvo)) {
      this.exibirAlertaRestricaoRegistroAtividade();
      return;
    }

    this.router.navigate(['registro-saida', 'adicionar-registro-atividade'],
      {
        queryParams: {
          id: codigoJornada,
          ...(this.isCheckoutFlow ? { flow: 'checkout' } : {})
        }
      });
  }
  async getJornadaEmAberto() {
    this.spinnerService.show();
    const cpf = this.getCpfUsuarioLogado();
    if (!cpf) {
      this.toastr.error('CPF do usuário não encontrado.');
      this.lstAtividades = [];
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(cpf));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.lstAtividades = [];
      this.spinnerService.hide();
      return;
    }

    this.jornadaNaoFinalizada = response.data;
    this.codigoJornadaEmAberto = this.jornadaNaoFinalizada?.codigoJornada ?? null;
    if (!this.jornadaNaoFinalizada) {
      this.lstAtividades = [];
      if (this.isCheckoutFlow) {
        this.toastr.warning('Para registrar atividades e confirmar saída, primeiro registre a entrada (check-in).', 'Atenção!');
        this.router.navigate(['/home']);
        this.spinnerService.hide();
        return;
      }

      this.toastr.warning("Nenhuma jornada em aberto encontrada.", "Atenção!");
      this.spinnerService.hide();
      return;
    }

    if ((!this.jornadaNaoFinalizada.atividades || this.jornadaNaoFinalizada.atividades.length === 0)
      && this.jornadaNaoFinalizada.codigoJornada) {
      const jornadaResponse = await lastValueFrom(this.psicologoService.getJornadaPorId(this.jornadaNaoFinalizada.codigoJornada))
        .catch(err => this.errorHandler.handleResultError(err));

      if (jornadaResponse?.isSucess) {
        this.jornadaNaoFinalizada = jornadaResponse.data;
      }
    }

    this.lstAtividades = this.jornadaNaoFinalizada?.atividades ?? [];

    // if (!this.isToday()) {
    //   this.toastr.warning("Inicie uma jornada hoje para adicionar atividades", "Atenção!");
    //   this.spinner.hide();
    //   return;
    // }

    this.toggleDisabledDateInput();
    this.calcularHoras();
    this.passaValoresJornadaParaAtividade();
    this.toastr.success("Jornada encontrada com sucesso!");
    this.spinnerService.hide();
    // if (response.data !== null) {


    //   var dataInicioJornada = new Date(response.data.dataInicio);
    //   var diaDiferenca = new Date().getDate() - dataInicioJornada.getDate();
    //   // Revisa si existe diferencia de dias
    //   if(diaDiferenca > 0){
    //     this.mensagemRetornoSucesso = `Jornada maior que 1 dia, iniciada as ${this.jornadaNaoFinalizada!.horaInicio}`;
    //     this.toastr.warning('Check-out do último dia trabalhado ainda não realizado. Favor efetuar o acerto na tela de Painel de Atividade do Psicólogo');
    //     this.otroDia = true;
    //   } else {
    //     this.mensagemRetornoSucesso = `Jornada iniciada as ${this.jornadaNaoFinalizada!.horaInicio}`;
    //     this.toastr.warning(`Jornada em andamento, iniciada as ${this.jornadaNaoFinalizada!.horaInicio}`, 'Atenção!');
    //     this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
    //   }
    // } else {
    //   this.jornadaNaoFinalizada = null;
    //   this.mensagemRetornoSucesso = '';
    //   this.relogioPontoService.updateStatusJornada(StatusJornada.NaoIniciada);
    //   this.infoRegistroPontoSucesso = false;
    // }

  }


  isToday(): boolean {
    const dataInicio = new Date(this.jornadaNaoFinalizada!.dataInicio);
    const dataHoje = new Date();

    return dataInicio.getDate() === dataHoje.getDate() &&
      dataInicio.getMonth() === dataHoje.getMonth() &&
      dataInicio.getFullYear() === dataHoje.getFullYear();
  }


  isTodayDataSaida(): boolean {

    const dataSaida = this.parseDateInputAsLocalDate(this.form.dataSaida.value);
    const dataHoje = new Date();


    return dataSaida.getDate() === dataHoje.getDate() &&
      dataSaida.getMonth() === dataHoje.getMonth() &&
      dataSaida.getFullYear() === dataHoje.getFullYear();
  }
  calculaTotalHorasTrabalhadas() {
    this.totalHorasTrabalhadas = this.psicologoUtilsService.calculaTotalHorasTrabalhadas(this.jornadaNaoFinalizada);
  }

  calculaTotalHorasAtividades() {
    const horario = new Date(0, 0, 0, 0, 0);
    if (this.lstAtividades.length === 0) {
      this.totalHorasAtividades = horario;
      return;
    }

    this.lstAtividades.forEach(atividade => {
      const tempoAtividade = atividade.tempoAtividade;
      const minutos = parseInt(tempoAtividade, 10);
      horario.setMinutes(horario.getMinutes() + minutos);
    })


    this.totalHorasAtividades = horario;
  }

  calculaTotalHorasTempoRegistro() {
    const horario = this.psicologoUtilsService.calculaTotalHorasTempoRegistro(this.jornadaNaoFinalizada);
    this.HorariocheckOut = undefined;

    if (this.jornadaNaoFinalizada?.dataFim || this.jornadaNaoFinalizada?.stAjusteAprovacaoSaida == 1) {
      const dataFimTotal = this.jornadaNaoFinalizada?.stAjusteAprovacaoSaida == 1
        ? new Date(this.jornadaNaoFinalizada?.hrAjusteSaida!)
        : new Date(this.jornadaNaoFinalizada?.dataFim!);
      dataFimTotal.setSeconds(0, 0);
      this.HorariocheckOut = dataFimTotal;
    }
    this.totalHorasTempoRegistro = horario;
  }

  calculaTempoDeslocamento(){
    return this.psicologoUtilsService.calculaTempoDeslocamento(this.jornadaNaoFinalizada);
  }

  async abrirModalFinalizarJornada() {
    if (!this.jornadaNaoFinalizada?.dataInicio || this.jornadaNaoFinalizada?.dataFim) {
      this.toastr.warning('Não há jornada ativa para confirmar saída.', 'Atenção!');
      return;
    }

    if (this.isTodayDataSaida())
      this.relogioPontoService.abrirModalFinalizarJornada();
    else {
      const dataSaida = this.parseDateInputAsLocalDate(this.form.dataSaida.value);
      const agora = new Date();
      dataSaida.setHours(agora.getHours(), agora.getMinutes(), 0, 0);
      this.relogioPontoService.abrirModalFinalizarJornada(dataSaida);
    }
  }

  cancelarFluxoCheckout() {
    this.router.navigate(['/home']);
  }

  async getJornadaPorId(id: number) {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getJornadaPorId(id));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.jornadaNaoFinalizada = response.data;
    this.lstAtividades = this.jornadaNaoFinalizada?.atividades ?? [];
    this.toggleDisabledDateInput();

    this.calcularHoras();
    this.passaValoresJornadaParaAtividade();
    this.toastr.success("Jornada encontrada com sucesso!");
    this.spinnerService.hide();

  }


  private passaValoresJornadaParaAtividade() {
    this.lstAtividades = this.lstAtividades.map(atividade => {
      atividade.poloDiretoria = this.jornadaNaoFinalizada?.poloDiretoria;
      atividade.escola = this.jornadaNaoFinalizada?.escolaFormatada;
      const data = new Date(atividade.dataAtividade).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      atividade.dataAtividade = data;
      const tempoAtividadeDate = new Date(0, 0, 0, 0, 0);
      tempoAtividadeDate.setMinutes(Number(atividade.tempoAtividade));
      atividade.tempoAtividade = `${tempoAtividadeDate.getHours() <= 9  ? '0':''}${tempoAtividadeDate.getHours()}:${tempoAtividadeDate.getMinutes() <= 9  ? '0':''}${tempoAtividadeDate.getMinutes()}`;
      return atividade;
    });
  }

  private OnClickAcao(e: any, cell: any) {
    // Evento de click na célula para capturar os botões
    const row = cell.getRow().getData(); // Dados da linha
    const target = e.target; // Elemento clicado
    const codigoAtividade = row.codigoAtividade
    if (target.classList.contains('fa-eye')) {
      this.router.navigate(['registro-saida', 'jornada'],
        { queryParams: { id: this.jornadaNaoFinalizada?.codigoJornada, atividade: codigoAtividade } });
    } else if (target.classList.contains('fa-edit')) {
      if (!this.podeInserirAtividadeNaJornada()) {
        this.exibirAlertaRestricaoRegistroAtividade();
        return;
      }

      this.router.navigate(['registro-saida', 'editar-registro-atividade'],
        { queryParams: { atividadeId: codigoAtividade,jornadaId:this.jornadaNaoFinalizada?.codigoJornada } });
    } else if (target.classList.contains('fa-trash')) {
      this.atividadeIdSelecionada = codigoAtividade;
      this.toggleModalExcluirAtividade();
    }
  }


  toggleModalExcluirAtividade() {
    this.showModal = !this.showModal;
  }

  toggleModalAprovacao() {
    if(!this.showModalAprovacao){
      this.formJustificarTempoRegistro.get('justificativa')?.addValidators([Validators.required, Validators.maxLength(500),Validators.minLength(150)]);
      this.formJustificarTempoRegistro.get('justificativa')?.updateValueAndValidity();
    }
    this.showModalAprovacao = !this.showModalAprovacao;
  }
  async OnExcluirAtividade() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.setExcluirAtividade(this.atividadeIdSelecionada!,
      this.userLogado?.codigoUsuario!,this.userLogado?.nome!
    ))
    .catch(err => this.convivaErrors.handleResultError(err));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      this.toggleModalExcluirAtividade();
      return;
    }

    this.toastr.success("Atividade excluída com sucesso!");
    this.atividadeIdSelecionada = undefined;
    this.toggleModalExcluirAtividade();

    this.spinnerService.hide();
    await this.getJornadaPorId(this.jornadaNaoFinalizada!.codigoJornada);
  }


  calcularHoras() {
    this.calculaTotalHorasAtividades();
    this.calculaTotalHorasTempoRegistro();
    this.calculaTotalHorasTrabalhadas();

  }

  toggleDisabledDateInput() {
    const dataInicio = new Date(this.jornadaNaoFinalizada!.dataInicio);
    this.form.dataSaida.setValue(this.formatDateToInputLocal(dataInicio));
    if (this.isToday() || this.jornadaNaoFinalizada!.dataFim) {
      this.form.dataSaida.disable();
    }

  }

  private parseDateInputAsLocalDate(value: string | Date): Date {
    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    const [yearStr, monthStr, dayStr] = String(value).split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);

    if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
      return new Date(year, month - 1, day);
    }

    const parsed = new Date(value);
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  }

  private formatDateToInputLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getCpfUsuarioLogado(): string {
    const cpfUsuario = this.userLogado?.cpf
      ?? (this.userLogado?.DadosUsuario?.[0]?.Cpf != null
        ? String(this.userLogado.DadosUsuario[0].Cpf)
        : '');

    return cpfUsuario.replace(/\D/g, '');
  }

  private async carregarJornadaAtivaUsuario(): Promise<void> {
    const cpf = this.getCpfUsuarioLogado();
    if (!cpf) {
      this.jornadaAtivaUsuario = undefined;
      return;
    }

    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(cpf));
      if (response?.isSucess && response.data) {
        this.jornadaAtivaUsuario = response.data;
        this.codigoJornadaEmAberto = response.data.codigoJornada ?? null;
        return;
      }
    } catch {
      // Mantém indefinido quando a API falhar.
    }

    this.jornadaAtivaUsuario = undefined;
    this.codigoJornadaEmAberto = null;
  }

  private perfilExigeJornadaAtivaParaInserirAtividade(): boolean {
    const perfil = this.userLogado?.codigoPerfil;
    return perfil === Perfil.Psicólogo || perfil === Perfil.CoordenadorPsicologo;
  }

  private podeInserirAtividadeNaJornada(jornadaAlvo?: JornadaPsicologo): boolean {
    const alvo = jornadaAlvo ?? this.jornadaNaoFinalizada;
    if (!alvo?.codigoJornada || !alvo?.dataInicio) {
      return false;
    }

    if (jornadaEstaAprovada(alvo)) {
      return false;
    }

    if (this.isCheckoutFlow) {
      return !possuiCheckoutEfetivo(alvo);
    }

    if (!this.perfilExigeJornadaAtivaParaInserirAtividade()) {
      return true;
    }

    return this.codigoJornadaEmAberto != null;
  }

  private exibirAlertaRestricaoRegistroAtividade(): void {
    if (jornadaEstaAprovada(this.jornadaNaoFinalizada)) {
      this.toastr.warning('Não é permitido adicionar atividades em jornadas aprovadas.');
      return;
    }

    this.toastr.warning('Registro de atividades permitido apenas durante jornada ativa.');
  }

  async OnEnviarAtividade() {

    this.spinnerService.show();
    const atividadesIds = this.jornadaNaoFinalizada?.atividades.map(x=>x.codigoAtividade);
    const response = await lastValueFrom(this.psicologoService.setEnviarParaAprovacaoAtividades(atividadesIds!,
      this.userLogado?.codigoUsuario!,
      this.userLogado?.nome!,
      this.jornadaNaoFinalizada?.codigoJornada
    )).catch(err =>  this.convivaErrors.handleResultError(err));

    if(!response.isSucess){
      this.spinnerService.hide();
      this.toastr.error(response.message);
      return;
    }
    this.toggleModalAprovacao();
    await this.getJornada();
    this.toastr.success("Atividades enviadas para a aprovação com sucesso!");
    this.spinnerService.hide();
  }

  // tempoRegistroMaiorQue30min():boolean{
  //   return this.totalHorasTempoRegistro?.getHours()! > 0 || this.totalHorasTempoRegistro?.getMinutes()! >= 30;
  // }

}


